import React, { useState, useEffect, Fragment } from "react";
import apiRequest from "../../Api";
import BasicTable from "../../components/VirtuosoTable";
import ReactToast from "../../components/Toast";
import { Spinner } from "react-bootstrap";

function ReturnInventoryListing(props) {
  const [filterData, setFilterData] = useState([]);
  const [headerInfo, setHeaderInfo] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isLoading) {
      CallAPiList();
    }
  }, [isLoading]); // Updated dependency array to contain isLoading only

  let headerData = [
    {
      label: "Item Name",
      render: (data) => data.item_name,
      width: "100px",
      className: "text-left",
    },
    {
      label: "OP",
      render: (data) => data.op_qty,
      className: "text-center",
    },
    {
      label: "SALE",
      render: (data) => data.sale_qty,
      className: "text-center",
    },    
    {
      label: "RET",
      render: (data) => data.ret_qty,
      className: "text-center",
    },
    {
      label: "CLOSING",
      render: (data) => data.cls_qty,
      className: "text-center",
    }  
  ];

  const CallAPiList = async () => {
  setIsLoading(true)
    try {
      const url = process.env.REACT_APP_API_BASE;

      let apiSetting = {
        method: "POST",
        // Include your API parameters here
        apiParams: {
          partypkid: 15,
        },
      };

      let listingData = await apiRequest(
        `${url}OrderPanelApi/partyReturnInventoryReport`,
        apiSetting
      );

      if (listingData.data && listingData.data.success == 1) {
        // Fixed comparison
        setFilterData(listingData.data.data.data);
        setHeaderInfo(listingData?.data?.data?.heading_info);
      } else {
        throw new Error(listingData.data.message);
      }
    } catch (error) {
      ReactToast({ type: "error", message: error.message });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Fragment>
      <div className="d-flex w-100 flex-column flex-md-row justify-content-between align-items-center">
        <div className="text-center text-md-start">
          <h5>Return Inventory Info Report</h5>
          <small>{headerInfo?.name}</small>
        </div>        
      </div>
    
      {isLoading&&<div style={{minHeight:'250px', width:'100%', textAlign:"center", placeContent:"center"}}><Spinner animation="border" variant="secondary" /></div>}
      {!isLoading && filterData.map((item, idx) => (
        <>
        <div className="inner_heading" style={{background : "#f3f3f3"}}>{item.title}</div>
        <BasicTable
          headers={headerData}
          data={item?.table_data||[]}
          footerContent={<div></div>}
          other_params ={{ class: "return_inv_report",height:`calc(45px + (${item?.table_data?.length} * 45px))` }}
        />
        </>
      ))}
    </Fragment>
  );
}

export default ReturnInventoryListing;
